import { isBooleanTrue, isListNotEmpty, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class ProductVariantSupplierMapping {
    quantity = 0; // quantity for practice
    refId = null; // reference Id for the variant mapping, e.g. medID from practice system
    refills = 0; // number of refills allowed
    instructions = null; // instructions for the variant
    supplierId = null; // supplier Id for the variant mapping
    supplierQuantity = 0; // quantity of the variant for the supplier
    supplierRefId = null; // reference Id for the variant mapping in the supplier system, e.g. medID/productID for supplier
    supplierName = null; // supplier's product name, e.g. PerfectRx productName
    supplierDescription = null; // verbose product description sent to the supplier; may be identical to supplierName
    supplierStrength = null; // explicit strength; when set, PerfectRx treats the mapping as migrated to explicit fields
    supplierUnits = null; // supplier's dispensing units, e.g. vial, each, tablet
    supplierForm = null; // supplier's dosage form; stored for integrations not yet wired to it
    supplierRoute = null; // supplier's route of administration; stored for integrations not yet wired to it
    supplierDaysSupply = 0; // explicit days supply; 0 means unset
    supplierNotes = null; // free-text note transmitted on the supplier order
    addOns = []; // array of ProductVariantSupplierMappingAddOn for any add ons associated with this variant mapping

    rxomMedicationId = null; // medication id in the RXOM middleware; not a supplier value

    constructor(obj) {
        if (isObjectNotEmpty(obj)) {
            if (isNumberGreaterThanOrEqualToZero(obj.quantity)) { this.quantity = obj.quantity; }
            if (isStringNotEmpty(obj.refId)) { this.refId = obj.refId; }
            if (isNumberGreaterThanOrEqualToZero(obj.refills)) { this.refills = obj.refills; }
            if (isStringNotEmpty(obj.instructions)) { this.instructions = obj.instructions; }
            if (isStringNotEmpty(obj.supplierId)) { this.supplierId = obj.supplierId; }
            if (isNumberGreaterThanOrEqualToZero(obj.supplierQuantity)) { this.supplierQuantity = obj.supplierQuantity; }
            if (isStringNotEmpty(obj.supplierRefId)) { this.supplierRefId = obj.supplierRefId; }
            if (isStringNotEmpty(obj.supplierName)) { this.supplierName = obj.supplierName; }
            if (isStringNotEmpty(obj.supplierDescription)) { this.supplierDescription = obj.supplierDescription; }
            if (isStringNotEmpty(obj.supplierStrength)) { this.supplierStrength = obj.supplierStrength; }
            if (isStringNotEmpty(obj.supplierUnits)) { this.supplierUnits = obj.supplierUnits; }
            if (isStringNotEmpty(obj.supplierForm)) { this.supplierForm = obj.supplierForm; }
            if (isStringNotEmpty(obj.supplierRoute)) { this.supplierRoute = obj.supplierRoute; }
            if (isNumberGreaterThanOrEqualToZero(obj.supplierDaysSupply)) { this.supplierDaysSupply = obj.supplierDaysSupply; }
            if (isStringNotEmpty(obj.supplierNotes)) { this.supplierNotes = obj.supplierNotes; }
            if (isListNotEmpty(obj.addOns)) { this.addOns = obj.addOns.map((addOn) => new ProductVariantSupplierMappingAddOn(addOn).toDto()); }
            if (isStringNotEmpty(obj.rxomMedicationId)) { this.rxomMedicationId = obj.rxomMedicationId; }
        }
    }

    toDto = () => {
        return {
            quantity: this.quantity,
            refId: this.refId,
            refills: this.refills,
            instructions: this.instructions,
            supplierId: this.supplierId,
            supplierQuantity: this.supplierQuantity,
            supplierRefId: this.supplierRefId,
            supplierName: this.supplierName,
            supplierDescription: this.supplierDescription,
            supplierStrength: this.supplierStrength,
            supplierUnits: this.supplierUnits,
            supplierForm: this.supplierForm,
            supplierRoute: this.supplierRoute,
            supplierDaysSupply: this.supplierDaysSupply,
            supplierNotes: this.supplierNotes,
            addOns: this.addOns,
            rxomMedicationId: this.rxomMedicationId,
        };
    }
}

export class ProductVariantSupplierMappingAddOn {
    name = null;
    sku = null;
    productId = null;
    variantId = null;
    quantity = 0;
    isUnique = false; // deprecated - use scope instead. kept for backward compatibility
    quantityMode = 'FIXED'; // enum AddOnQuantityModes: FIXED, PER_UNIT, PER_LINE_ITEM
    scope = 'PER_PRODUCT'; // enum AddOnScopes: PER_PRODUCT, PER_SHIPMENT
    shipmentQuantityMode = 'SUM'; // enum AddOnShipmentQuantityModes: MAX, SUM - only used when scope is PER_SHIPMENT
    requiresPrescription = false; // whether this add-on needs a Beluga prescription for this supplier mapping

    constructor(obj) {
        if (isObjectNotEmpty(obj)) {
            if (isStringNotEmpty(obj.name)) { this.name = obj.name; }
            if (isStringNotEmpty(obj.sku)) { this.sku = obj.sku; }
            if (isStringNotEmpty(obj.productId)) { this.productId = obj.productId; }
            if (isStringNotEmpty(obj.variantId)) { this.variantId = obj.variantId; }
            if (isNumberGreaterThanOrEqualToZero(obj.quantity)) { this.quantity = obj.quantity; }
            if (isBooleanTrue(obj.isUnique)) { this.isUnique = true; }
            if (isStringNotEmpty(obj.quantityMode)) { this.quantityMode = obj.quantityMode; }
            if (isStringNotEmpty(obj.scope)) { this.scope = obj.scope; }
            if (isStringNotEmpty(obj.shipmentQuantityMode)) { this.shipmentQuantityMode = obj.shipmentQuantityMode; }
            if (isBooleanTrue(obj.requiresPrescription)) { this.requiresPrescription = true; }
        }
    }

    toDto = () => {
        return {
            name: this.name,
            sku: this.sku,
            productId: this.productId,
            variantId: this.variantId,
            quantity: this.quantity,
            isUnique: this.isUnique,
            quantityMode: this.quantityMode,
            scope: this.scope,
            shipmentQuantityMode: this.shipmentQuantityMode,
            requiresPrescription: this.requiresPrescription,
        };
    }
}

export default ProductVariantSupplierMapping;
